<template>
  <div
    class="fixed w-full bottom-0 left-0 bg-surface-primary px-16 pt-8 pb-android-chrome-safe-8 flex justify-center md:px-24 md:py-16 border-0 border-t-sm border-border-tertiary z-sticky"
  >
    <slot />
  </div>
</template>
